import { inject } from '@angular/core';
import type { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot } from '@angular/router';
import { map, tap, withLatestFrom } from 'rxjs';
import { PagePath } from '../enums/page-path.enum';
import { DemographicsStateService } from '../services/demographics-state.service';
import { GuardsContextService } from '../services/guards-context.service';
import { NavigationService } from '../services/navigation.service';

export const selectedZipGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
  guardsContextService = inject(GuardsContextService),
  demographicsStateService = inject(DemographicsStateService),
  navigationService = inject(NavigationService)
) => {
  return guardsContextService.getIsProcessingAuth$().pipe(
    withLatestFrom(demographicsStateService.hasSelectedZipAndFips$()),
    tap(([isProcessingAuth, hasSelectedZipAndFips]) => {
      if (!isProcessingAuth && !hasSelectedZipAndFips) {
        navigationService.navigateToPagePath([PagePath.HOME]);
      }
    }),
    map(([isProcessingAuth, hasSelectedZipAndFips]) => isProcessingAuth || hasSelectedZipAndFips)
  );
};
